import { Map, Record } from "immutable"

import {
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    updateCreateModel,
    isMappingSame,
    mappingToAPI
} from "../model-utils"
import { idify } from "../../reducers/paging/paging-reducer-utils"

export const DimensionModel = new Record({
    id: "",
    can_edit: false,
    can_view: true,
    description: "",
    image_url: "",
    imagePreviewURL: undefined,
    inherit_placeholders: false,
    mappings: [],
    name: "",
    owners: [],
    placeholders: [],
    primary_topic: null,
    status: "Active",
    subtitle: "",
    topics: [],
    viewers: []
})

export function DimensionCreateModel() {
    return Map({
        description: "",
        name: "",
        status: "Draft"
    })
}

export const normalisingFields = ["topics"]
const addRemoveFields = [
    "topics",
    "placeholders",
    "owners",
    "viewers",
    {
        name: "mappings",
        comparator: isMappingSame,
        transformAdd: mappings => mappings.map(mappingToAPI),
        transformRemove: idify
    }
]

export const normalise = dimension =>
    normaliseModel(dimension, ...normalisingFields)
export const hydrate = (dimension, ...entityStates) =>
    hydrateModel(dimension, normalisingFields, entityStates)

export const updateDimensionChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) => updateChangeModel(name, value, changeModel, workingModel, addRemoveFields)

export const updateDimensionCreateModel = (
    name,
    value,
    createModel,
    workingModel
) => updateCreateModel(name, value, createModel, workingModel, addRemoveFields)
